import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Card, Divider, Flex, Input, Select, Table } from "antd";
import axios from "axios";
import { differenceBy, findIndex } from "lodash";
import { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { NavLink } from "react-router-dom";
import { baseUrl } from "../../../components/common/baseUrl";
import { useNotify } from "../../../components/Notification";
import { settings } from "../../../utils/config";
import ModalAddPermissionInMenu from "./ModalAddPermissionInMenu";
import ModalIcon from "./ModalIcon";

const CreateMenuForm = (props) => {
  const { handleSubmit, title, initData } = props;
  const notify = useNotify();
  const hasAccessToken = settings?.getCookie("access_token");

  //#region state
  const [open, setOpen] = useState(false);
  const [openModalIcon, setOpenModalIcon] = useState(false);
  const [listMenu, setListMenu] = useState([]);
  //#endregion state

  //#region hook form
  const hookForm = useForm({
    defaultValues: {
      name: "",
      slug: "",
      url: "",
      key: "",
      icon: "",
      parent_id: null,
      listPermission: [],
    },
  });
  const { fields, append, remove } = useFieldArray({
    name: `listPermission`,
    control: hookForm.control,
  });
  const permissionFields = Array.isArray(fields) ? fields : [];
  const watchedPermissions = hookForm.watch(`listPermission`);
  const selectedPermissionIds = Array.isArray(watchedPermissions)
    ? watchedPermissions
        .map(
          (permission) =>
            permission.permission_id || permission?.pivot?.permission_id || permission.id
        )
        .filter(Boolean)
    : [];
  //#endregion hookform

  //#region table
  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (_text, _record, index) => {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: "Mô tả",
      dataIndex: "label",
      key: "3",
    },
    {
      title: "Mã permission",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      render: (name) => {
        return <p style={{ color: "#4096ff" }}>{name}</p>;
      },
    },
    {
      title: "Hành động",
      dataIndex: "operation",
      align: "center",
      width: "12.5%",
      render: (_, record) => {
        return (
          <div>
            <Button
              type="primary"
              children={"Hủy"}
              danger
              onClick={() =>
                handleRemovePermission(
                  record.permission_id || record?.pivot?.permission_id
                )
              }
            />
          </div>
        );
      },
    },
  ];
  //#endregion table

  const handleAddPermission = (permissions) => {
    const permissionList = Array.isArray(permissions) ? permissions : [];
    // Dam bao moi permission co permission_id, khong phai id noi bo cua useFieldArray.
    const tempPermission = permissionList.map((p) => ({
      ...p,
      permission_id: p.id,
      id: p.id,
    }));
    const listNotExitedPermission = differenceBy(tempPermission, permissionFields, "id");

    append(listNotExitedPermission);
  };

  const handleRemovePermission = (id) => {
    const newFields = permissionFields.map((item) => ({
      ...item,
      permission_id: item?.permission_id || item.pivot?.permission_id,
    }));

    const indexOfItemToRemove = findIndex(
      newFields,
      (o) => o.permission_id === id
    );

    if (indexOfItemToRemove >= 0) {
      remove(indexOfItemToRemove);
    }
  };

  const fetchActions = async (page = 1, perPage = 10) => {
    try {
      const url = `${baseUrl}/api/v1/security/menus`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${hasAccessToken}`,
        },
      });

      if (response.data.success && response.data.data) {
        const result = response.data.data;
        setListMenu(
          Array.isArray(result)
            ? result.map((item) => ({ label: item.name, value: item.id }))
            : []
        );
      }
    } catch (error) {
      notify.error({
        message: "Thất bại",
        description: error.response.data?.message,
      });
    } finally {
    }
  };
  //#endregion function

  //#region useEffect
  useEffect(() => {
    if (initData) {
      hookForm.reset({
        name: initData.name,
        url: initData.url,
        key: initData.slug,
        icon: initData.icon,
        parent_id: initData.parent_id,
        listPermission: initData.permissions || [],
      });
    }
  }, [initData]);

  useEffect(() => {
    fetchActions();
  }, []);
  //#endregion useEffect
  return (
    <Card title={title}>
      <Flex
        align="center"
        gap={10}
        justify="flex-start"
        style={{ width: "100%", paddingBottom: "10px" }}
      >
        <div style={{ flex: 1 }}>
          <label style={{ marginBottom: 8, display: "block" }}>
            Tên Menu<span style={{ color: "red" }}>*</span>
          </label>
          <Controller
            name="name"
            control={hookForm.control}
            rules={{ required: "Tên menu không được bỏ trống" }}
            render={({ field }) => <Input {...field} placeholder="Tên" />}
          />
          {hookForm?.formState?.errors?.name ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                minHeight: "16px",
                display: "block",
              }}
            >
              {hookForm.formState.errors.name.message}
            </span>
          ) : (
            <span style={{ minHeight: "16px", display: "block" }} />
          )}
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ marginBottom: 8, display: "block" }}>
            Key<span style={{ color: "red" }}>*</span>
          </label>
          <Controller
            name="key"
            control={hookForm.control}
            rules={{ required: "Key không được bỏ trống" }}
            render={({ field }) => <Input {...field} placeholder="Key" />}
          />
          {hookForm?.formState?.errors?.key ? (
            <span
              style={{
                color: "red",
                fontSize: "12px",
                minHeight: "16px",
                display: "block",
              }}
            >
              {hookForm.formState.errors.key.message}
            </span>
          ) : (
            <span style={{ minHeight: "16px", display: "block" }} />
          )}
        </div>
      </Flex>
      <Flex
        align="center"
        gap={10}
        justify="flex-start"
        style={{ width: "100%", paddingBottom: "10px" }}
      >
        <div style={{ flex: 1 }}>
          <label style={{ marginBottom: 8, display: "block" }}>Đường dẫn</label>
          <Controller
            name="url"
            control={hookForm.control}
            render={({ field }) => <Input {...field} placeholder="Đường dẫn" />}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label style={{ marginBottom: 8, display: "block" }}>Icon</label>
          <Controller
            name="icon"
            control={hookForm.control}
            render={({ field }) => (
              <Input
                {...field}
                placeholder="icon"
                onClick={() => setOpenModalIcon(true)}
                style={{ cursor: "pointer" }}
                readOnly
                prefix={
                  field.value ? (
                    <i className={field.value} style={{ fontSize: 16 }} />
                  ) : null
                }
              />
            )}
          />
        </div>
      </Flex>
      <Flex
        align="center"
        gap={10}
        justify="flex-start"
        style={{ width: "100%", paddingBottom: "10px" }}
      >
        <div style={{ flex: 0.5 }}>
          <label style={{ marginBottom: 8, display: "block" }}>Menu cha</label>
          <Controller
            name="parent_id"
            control={hookForm.control}
            render={({ field }) => (
              <Select
                {...field}
                showSearch
                style={{ width: "100%" }}
                placeholder="Chọn menu cha"
                optionFilterProp="label"
                options={listMenu}
              />
            )}
          />
        </div>
      </Flex>
      <Divider />
      <Flex
        align="center"
        justify="space-between"
        style={{ paddingBottom: "10px" }}
      >
        <span style={{ fontWeight: "bold" }}>Danh sách quyền </span>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          onClick={() => setOpen(true)}
        >
          Thêm quyền
        </Button>
      </Flex>
      <Table
        scroll={{ x: "max-content" }}
        columns={columns}
        dataSource={permissionFields.map(({ children, ...rest }) => rest)}
        rowKey="id" // id của permission
        pagination={false}
        childrenColumnName="__none__"
        style={{ paddingBottom: "20px" }}
      />
      {open && (
        <ModalAddPermissionInMenu
          isOpen={open}
          onCancel={() => setOpen(false)}
          handleRemovePermission={(id) => handleRemovePermission(id)}
          handleSelectPermission={(permission) =>
            handleAddPermission(permission)
          }
          existedListingPermission={selectedPermissionIds}
        />
      )}

      {openModalIcon && (
        <ModalIcon
          isOpen={openModalIcon}
          onCancel={() => setOpenModalIcon(false)}
          handleSelectIcon={(icon) => hookForm.setValue("icon", icon)}
        />
      )}
      <Flex align="center" justify="end" gap={10}>
        <NavLink to="/menu">
          <Button>Quay lại</Button>
        </NavLink>
        <Button type="primary" onClick={hookForm.handleSubmit(handleSubmit)}>
          {initData ? "Cập nhật" : "Thêm"}
        </Button>
      </Flex>
    </Card>
  );
};
export default CreateMenuForm;
